import { SwarovskiOptikClientCart, TypedMoney } from "@swo/storefront";
import { option as O } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { EcommerceProductVariant } from "./GoogleTagManagerIntegration";
import { nonEmpty } from "@swo/shared";

export function precisionRound(number: number, precision: number) {
  const factor = Math.pow(10, precision);

  return Math.round(number * factor) / factor;
}

export function toMoneyWithDecimals(money: TypedMoney): number {
  return money.centAmount / 10 ** money.fractionDigits;
}

export function getEcommerceProductVariant(
  lineItem: SwarovskiOptikClientCart["lineItems"][number],
  segment: { id: string; key: string },
): Promise<Array<EcommerceProductVariant>> {
  if (lineItem.data.tag === "bundle") {
    const ret: Array<EcommerceProductVariant> = lineItem.data.bundleElements
      .map(be => {
        const key = be.variant.key;

        if (!key) {
          return undefined;
        }

        const { variantKey, category: variantCategory } = be.extendedInfo;
        const variantSku = be.variant.sku;

        return {
          name: be.name,
          id: variantSku || "-",
          price: toMoneyWithDecimals(lineItem.price),
          category: pipe(
            variantCategory,
            O.fromNullable,
            O.getOrElse(() => {
              console.warn(`Product ${lineItem.id} has no category.`);
              return "";
            }),
          ),
          quantity: lineItem.quantity,
          dimension10: segment.key,
          dimension7: "in-stock" as const,
        };
      })
      .filter(nonEmpty);

    return Promise.resolve(ret);
  }

  const { variantKey, category: variantCategory } = lineItem.data.extendedInfo;
  const variantSku = lineItem.data.variant.sku;

  return Promise.resolve([
    {
      name: lineItem.data.name,
      id: variantSku || "-",
      price: toMoneyWithDecimals(lineItem.price),
      category: pipe(
        variantCategory,
        O.fromNullable,
        O.getOrElse(() => {
          console.warn(`Product ${lineItem.id} has no category.`);
          return "";
        }),
      ),
      quantity: lineItem.quantity,
      dimension10: segment.key,
      dimension7: "in-stock",
    },
  ]);
}
